import React, { useEffect, useRef, useState } from 'react';
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { setIsDist, setIsUlb, setIsWard } from "../../store/slice/currentStageSlice";
import * as XLSX from 'xlsx';
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from "react-router-dom";
import Map from "@arcgis/core/Map";
import MapView from "@arcgis/core/views/MapView";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import Query from "@arcgis/core/rest/support/Query";

import Graphic from "@arcgis/core/Graphic";
// PrimeReact Imports
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import "primereact/resources/themes/lara-light-indigo/theme.css"; // Theme
import "primereact/resources/primereact.min.css"; // Core CSS
import "primeicons/primeicons.css"; // Icons
import MapABPASS from '../../componets/MapABPASS';
import LayerControlPanel from '../../componets/LayerControlPanel';


// === Service URLs ===
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { data } from 'react-router-dom';


// ALL LAYERS
import { GROUPS }  from "../../componets/ALLlayerConfig.js";
const ABPass = ({ view, dataValueuniqueId }) => {
    // function ABPass({ view }) {
    const dispatch = useDispatch()
    const { isTheme, isBufferWidth, isToolHeight } = useSelector((state) => state.currentStage)
    const [districts, setDistricts] = useState([]);
    const [selectedDistrict, setSelectedDistrict] = useState("");
    const [districtCode, setDistrictCode] = useState("");
    const authData = useSelector(state => state.authToken.authData);

    const [ulbs, setUlbs] = useState([]);
    const [selectedUlb, setSelectedUlb] = useState("");
    const [ulbCode, setUlbCode] = useState("");
    const [refactive, setRefactive] = useState("0");
    const [wards, setWards] = useState([]);
    const [selectedWard, setSelectedWard] = useState("");
    const [wardCode, setWardCode] = useState("");
    const [active, setActive] = useState("total");
    const [activeSelect, setActiveSelect] = useState("area");
    const [isTableView, setIsTableView] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);

    const [filteredPropertyData, setFilteredPropertyData] = useState([]);
    const [PropertyData_TBL, setPropertyData_TBL] = useState([]);

    const [search, setSearch] = useState("");
    const [expanded, setExpanded] = useState({});
    const [checked, setChecked] = useState({});

    const [isLoading, setIsLoading] = useState(false);
    const [isTableLoading, setIsTableLoading] = useState(false);

    // State for PrimeReact DataTable
    const [columns, setColumns] = useState([]);
    const [first, setFirst] = useState(0); // Index of the first record
    const [rows, setRows] = useState(500); // Rows per page

    const [isLayerInfo, setIsLayerInfo] = useState({});
    const [mapLayers, setMapLayers] = useState({});

    const [isPayload, setIsPayload] = useState();
    const [layerVisibility, setLayerVisibility] = useState({});
    const [expandedGroups, setExpandedGroups] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [isChangeStage, setIsChangeStage] = useState(false);
    const [isOwnerDetails, setIsOwnerDetails] = useState();
    //19sep  Bhupen

    const [propertyData, setpropertyData] = useState();
    const [Relation_Id, setRelation_Id] = useState("0");
    const [selectedImageUrl, setSelectedImageUrl] = useState(null);
    const [selectedGISUniqeID, setselectedGISUniqeID] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);

    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();

    const [showDetails, setShowDetails] = useState(false);
    //19sep  Bhupen

    const [activeLang, setActiveLang] = useState("en");

    const handleSublayerToggle = (groupKey, sublayer, checked) => {
        setLayerVisibility((prev) => ({
            ...prev,
            [`${groupKey}_${sublayer.id}`]: checked,
        }));

        // Toggle ArcGIS layer visibility
        const targetLayer = mapLayers[groupKey];
        if (targetLayer) {
            const subLayer = targetLayer.findSublayerById(sublayer.id);
            if (subLayer) subLayer.visible = checked;
        }

        // Build payload with full info
        const payload = {
            groupKey,
            groupName: GROUPS.find((g) => g.key === groupKey)?.title,
            checked,
            sublayer, // full object
        };

        setIsPayload(payload)

        console.log("Clicked:", payload);

        // Emit to parent if callback provided
        // if (onSublayerToggle) {
        //     onSublayerToggle(payload);
        // }
    };

    const toggleExpandGroup = (title) => {
        setExpandedGroups((prev) =>
            prev.includes(title)
                ? prev.filter((g) => g !== title)
                : [...prev, title]
        );
    };

    const filteredGroups = GROUPS.filter((group) => {
        const titleMatch = group.title
            .toLowerCase()
            .includes(searchTerm.toLowerCase());
        const subMatch = group.sublayers.some((s) =>
            s.title.toLowerCase().includes(searchTerm.toLowerCase())
        );
        return titleMatch || subMatch;
    });

    const handleTableView = () => {
        setIsTableView(!isTableView)
    }



    const toggleExpand = (group) => {
        setExpanded((prev) => ({ ...prev, [group]: !prev[group] }));
    };

    // 🔑 pass group (layer), sublayer id, sublayer title
    const toggleCheck = (groupTitle, sublayerId, sublayerTitle) => {
        console.log(
            `Clicked: Group=${groupTitle}, Sublayer=${sublayerTitle}, ID=${sublayerId}`
        );


        setChecked((prev) => ({
            ...prev,
            [sublayerId]: !prev[sublayerId],
        }));


        setIsLayerInfo({ groupTitle, sublayerTitle, sublayerId })

        // Example: update ArcGIS map sublayer visibility
        // updateSublayerVisibility(groupTitle, sublayerId, !checked[sublayerId]);
    };



    // All dropdown loading functions (loadDistricts, loadUlbs, loadWards) remain unchanged.
    useEffect(() => {
        const loadDistricts = async () => {
            const url = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/3/query?where=1=1&outFields=districtname,dist_cd&returnGeometry=false&returnDistinctValues=true&f=geojson";
            try {
                const response = await fetch(url);
                const data = await response.json();

                if (authData?.UserType === "districtuser" || authData?.UserType === "User") {
                    const userDistrict = [{
                        districtName: authData.DistrictName,
                        districtCode: authData.DistrictCode,
                    }];
                    setDistricts(userDistrict);
                    setDistrictCode(authData.DistrictCode);
                    setSelectedDistrict(authData.DistrictName);
                    await loadUlbs(authData.DistrictCode);
                } else {
                    const formatted = data.features.map(f => ({
                        districtName: f.properties.districtname,
                        districtCode: f.properties.dist_cd,
                    }));
                    setDistricts(formatted);
                }
            } catch (err) {
                console.error("Error loading districts:", err);
            }
        };

        loadDistricts();
    }, [authData]);

    const loadUlbs = async (dist_cd) => {
        const url = `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/5/query?where=dist_cd='${dist_cd}'&returnGeometry=false&outFields=name,ulb_cd&returnDistinctValues=true&f=geojson`;
        try {
            const response = await fetch(url);
            const data = await response.json();
            if (authData?.UserType === "User") {
                const formattedUlbs = [{
                    ulbName: authData?.UlbName,
                    ulbCode: authData?.Ulb_Code,
                }];
                setUlbs(formattedUlbs);
                setUlbCode(authData?.Ulb_Code);
                setSelectedUlb(authData?.UlbName);
                await loadWards(authData?.Ulb_Code);
            } else if (data.features) {
                const formattedUlbs = data.features.map(f => ({
                    ulbName: f.properties.name,
                    ulbCode: f.properties.ulb_cd,
                }));
                setUlbs(formattedUlbs);
            }
        } catch (err) {
            console.error("Error loading ULBs:", err);
        }
    };

    const loadWards = async (ulb_cd) => {
        const url = `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/7/query?where=ulb_cd='${ulb_cd}'&returnGeometry=false&outFields=wardname,wardno&returnDistinctValues=true&f=geojson`;
        try {
            const response = await fetch(url);
            const data = await response.json();
            const formatted = data.features.map(f => ({
                wardName: f.properties.wardname,
                wardCode: f.properties.wardno,
                displayLabel: `${f.properties.wardno} - ${f.properties.wardname}`
            }));
            setWards(formatted);
        } catch (err) {
            console.error("Error loading wards:", err);
        }
    };

    const handleDistrictChange = async (selectedOption) => {
        if (!selectedOption) {
            handleRefresh();
            return;
        }
        const district = districts.find(d => d.districtCode === selectedOption.value);
        if (district) {
            setDistrictCode(district.districtCode);
            setSelectedDistrict(district.districtName);
            setUlbCode(""); setSelectedUlb(""); setWardCode(""); setSelectedWard("");
            await loadUlbs(district.districtCode);
            fetchAndZoomPropertyChanges({ dist_cd: district.districtCode });
        }
    };

    const handleUlbChange = async (selectedOption) => {
        if (!selectedOption) {
            setUlbCode(""); setSelectedUlb(""); setWardCode(""); setSelectedWard("");
            fetchAndZoomPropertyChanges({ dist_cd: districtCode }); // Refetch for the district
            return;
        }
        const ulb = ulbs.find(u => u.ulbCode === selectedOption.value);
        if (ulb) {
            setUlbCode(ulb.ulbCode); setSelectedUlb(ulb.ulbName); setWardCode(""); setSelectedWard("");
            await loadWards(ulb.ulbCode);
            fetchAndZoomPropertyChanges({ dist_cd: districtCode, ulb_cd: ulb.ulbCode });
        }
    };

    const handleWardChange = async (selectedOption) => {
        if (!selectedOption) {
            setWardCode(""); setSelectedWard("");
            fetchAndZoomPropertyChanges({ dist_cd: districtCode, ulb_cd: ulbCode }); // Refetch for the ULB
            return;
        }
        const ward = wards.find(w => w.wardCode === selectedOption.value);
        if (ward) {
            setWardCode(ward.wardCode); setSelectedWard(ward.wardName);
            fetchAndZoomPropertyChanges({ dist_cd: districtCode, ulb_cd: ulbCode, wardno: ward.wardCode });
        }
    };


    // const handleRowData = async (relationId) => {
    //     const [Graphic] = await loadModules(["esri/Graphic"]);

    //     const selectedFeature = propertyFeatures.find(
    //         (f) => f.attributes.relation_id === relationId
    //     );

    //     if (selectedFeature && view && highlightLayerRef.current) {
    //         // Zoom to the feature
    //         await view.goTo({
    //             target: selectedFeature.geometry,
    //             zoom: 50
    //         });

    //         // Clear previous highlights
    //         highlightLayerRef.current.removeAll();

    //         // Add red border highlight (transparent fill)
    //         const highlightGraphic = new Graphic({
    //             geometry: selectedFeature.geometry,
    //             symbol: {
    //                 type: "simple-fill",
    //                 color: [0, 0, 0, 0], // Transparent fill
    //                 outline: {
    //                     color: [255, 0, 0, 1], // Red border
    //                     width: 3
    //                 }
    //             }
    //         });

    //         highlightLayerRef.current.add(highlightGraphic);
    //     }
    // };



    useEffect(() => {
        const initLoad = async () => {
            setIsLoading(true);
            const filters = (authData?.UserType === "districtuser" || authData?.UserType === "User")
                ? { dist_cd: authData.DistrictCode, ulb_cd: authData.Ulb_Code, wardno: wardCode }
                : {};
            await fetchPropertyData({ ...filters, page: 1 });
            setIsLoading(false);
        };
        if (authData) initLoad();
    }, [authData, rows]); // Re-run if `rows` changes



    const generateTableHeaders = (data) => {
        if (!data || data.length === 0) return [];
        const excludedKeys = ["objectid", "dist_cd", "districtcode", "div_cd", "divisioncode", "Uaddgislab_sde_property_change_area", "ulb_cd", "ulbcode", "singlepage_id", "slumornonslum", "st_length(shape)", "st_area(shape)", "Photolink"];
        const excludedKeysLower = excludedKeys.map(key => key.toLowerCase());
        const keys = Object.keys(data[0]).filter(key => !excludedKeysLower.includes(key.toLowerCase()));
        return keys.map(key => ({
            field: key,
            header: key.replace(/([A-Z])/g, " $1").replace(/^./, str => str.toUpperCase()).replace(/_/g, " "),
        }));
    };

    // UPDATED data fetching function for PrimeReact
    const fetchPropertyData = async ({ dist_cd, ulb_cd, wardno, filterType = active, page = 1 }) => {
        setIsTableLoading(true);

        const baseUrl = "https://urbangis.mp.gov.in/server/rest/services/temp_n/abpas_property_mview/MapServer/1/query";
        const pageSize = rows;
        const offset = pageSize * (page - 1);

        const whereParts = [
            dist_cd && `dist_cd='${dist_cd}'`,
            ulb_cd && `ulb_cd='${ulb_cd}'`,
            wardno && `wardno='${wardno}'`,
            filterType && filterType !== "total" && filterType // Only add filterType if it's not "total"
        ].filter(Boolean);

        // If filterType is "total", only use the location filters (dist_cd, ulb_cd, wardno)
        // If filterType is not "total", use all filters including the filterType
        const where = whereParts.length > 0 ? whereParts.join(" AND ") : "1=1";

        try {
            // 🔹 Fetch count first
            const countUrl = `${baseUrl}?where=${encodeURIComponent(where)}&returnCountOnly=true&f=json`;
            const countRes = await fetch(countUrl);
            const countJson = await countRes.json();
            setTotalRecords(countJson.count || 0);

            // 🔹 Fetch records
            const url = `${baseUrl}?where=${encodeURIComponent(where)}&outFields=*&returnGeometry=false&f=json&resultOffset=${offset}&resultRecordCount=${pageSize}`;
            const response = await fetch(url);
            const json = await response.json();
            const properties = json.features.map(f => f.attributes);

            if (properties.length > 0) {
                setColumns(generateTableHeaders(properties));
            } else {
                setColumns([]);
            }

            setFilteredPropertyData(properties);
            setPropertyData_TBL(properties);
            setCurrentPage(page);
            setFirst(offset);

            return properties; // ✅ return so handleLoadMore works
        } catch (err) {
            console.error("Error fetching property data:", err);
            return [];
        } finally {
            setIsTableLoading(false);
        }
    };



    // NEW event handlers for PrimeReact Paginator
    const onPageChangePrimeReact = (event) => {
        setFirst(event.first);
        setRows(event.rows);
        const newPage = Math.floor(event.first / event.rows) + 1;
        fetchPropertyData({
            dist_cd: districtCode,
            ulb_cd: ulbCode,
            wardno: wardCode,
            filterType: active,
            page: newPage
        });
    };

    const onRowsChangePrimeReact = (newRows) => {
        setFirst(0);
        setRows(newRows);
        fetchPropertyData({
            dist_cd: districtCode,
            ulb_cd: ulbCode,
            wardno: wardCode,
            filterType: active,
            page: 1
        });
    };

    const filterProperties = (filterType) => {
        setActive(filterType);
        setCurrentPage(1);
        setFirst(0); // Reset paginator to the first page
        fetchPropertyData({
            dist_cd: districtCode,
            ulb_cd: ulbCode,
            wardno: wardCode,
            filterType: filterType,
            page: 1
        });
    };

    // fetchAndZoomPropertyChanges and other helpers remain the same
    const fetchAndZoomPropertyChanges = async ({ dist_cd, ulb_cd, wardno }) => {
        setIsLoading(true);
        await fetchPropertyData({ dist_cd, ulb_cd, wardno, page: 1 });
        const baseUrl = "https://urbangis.mp.gov.in/server/rest/services/temp_n/abpas_property_mview/MapServer/1/query";
        const where = [dist_cd && `dist_cd='${dist_cd}'`, ulb_cd && `ulb_cd='${ulb_cd}'`, wardno && `wardno='${wardno}'`].filter(Boolean).join(" AND ") || "1=1";
        const url = `${baseUrl}?where=${encodeURIComponent(where)}&outFields=*&returnGeometry=true&f=json`;
        try {
            const response = await fetch(url);
            const json = await response.json();
            const graphics = json.features.map(f => new Graphic({
                geometry: { type: "polygon", rings: f.geometry.rings, spatialReference: { wkid: 102100 } },
                symbol: { type: "simple-fill", color: [255, 0, 0, 0.4], outline: { color: [255, 0, 0], width: 1 } },
                attributes: f.attributes
            }));
            if (graphics.length && view) {
                view.graphics.removeAll(); // Clear previous graphics
                view.graphics.addMany(graphics);
                await view.goTo(graphics);
            }
        } catch (err) {
            console.error("Error fetching property change data:", err);
        } finally {
            setIsLoading(false);
        }
    };



    const PaginationControls = ({
        currentPage,
        totalRecords,
        pageSize,
        onPageChange,
        isLoading
    }) => {
        const totalPages = Math.ceil(totalRecords / pageSize);

        // Show pagination even if there's only one page, but disable navigation
        return (
            <div className="pagination-controls d-flex align-items-center">
                <button
                    className="btn btn-sm btn-outline-primary me-2"
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 1 || isLoading}
                >
                    &lt;
                </button>

                <span className="mx-2">
                    Page {currentPage} of {totalPages}
                    <small className="text-muted ms-2">
                        (Records {((currentPage - 1) * pageSize) + 1} - {Math.min(currentPage * pageSize, totalRecords)} of {totalRecords})
                    </small>
                </span>

                <button
                    className="btn btn-sm btn-outline-primary ms-2"
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage === totalPages || isLoading}
                >
                    &gt;
                </button>

                <div className="ms-3 text-muted">
                    <small>{pageSize} records per page</small>
                </div>
            </div>
        );
    };

    const handleLoadMore = async () => {
        // setIsLoadingMore(true);
        const nextPage = currentPage + 1;

        const newData = await fetchPropertyData({
            dist_cd: districtCode,
            ulb_cd: ulbCode,
            wardno: wardCode,
            filterType: active,
            page: nextPage
        });

        // Append new data to existing data (for infinite scroll)
        setFilteredPropertyData(prevData => [...prevData, ...newData]);
        setCurrentPage(nextPage);
    };

    const handleGetData = (item) => {
        if (item.title === "Total Properties") {
            filterProperties("total");
            setActive("total");
            setRefactive("0");
            // where: `relation_id='${PROPERTY_Relation_Id}'`,

        } else if (item.title === "MPHS Surveyed Properties") {
            filterProperties("Surveyed");
            setActive("Surveyed");
            setRefactive("0");
        } else if (item.title === "New Identified properties") {
            filterProperties("New");
            setActive("New");
            setRefactive("0");
        }
    }

    const downloadExcel = () => {
        if (filteredPropertyData.length === 0) {
            alert("No data available to download");
            return;
        }

        // Generate headers
        const headers = generateTableHeaders(filteredPropertyData);
        // Prepare data for Excel
        const excelData = filteredPropertyData.map(row => {
            const obj = {};
            headers.forEach(header => {
                obj[header.header] = row[header.field] !== undefined ? row[header.field] : "-";
            });
            return obj;
        });

        // Create worksheet
        const ws = XLSX.utils.json_to_sheet(excelData);
        // Create workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Property Data");
        // Generate Excel file
        const fileName = `Property_Data_${selectedDistrict || 'All'}_${selectedUlb || 'All'}_${selectedWard || 'All'}_${new Date().toISOString().split('T')[0]}.xlsx`;

        // Download the file
        XLSX.writeFile(wb, fileName);
    };

    const handleRefresh = async () => {
        // Reset all filter states
        setSelectedDistrict("");
        setDistrictCode("");
        setSelectedUlb("");
        setUlbCode("");
        setSelectedWard("");
        setWardCode("");
        setActive("total");
        setRefactive("1");
        setCurrentPage(1);
        setFirst(0);
        setSearch("");
        setSearchTerm("");

        // Reset layer visibility states
        setLayerVisibility({});
        setExpandedGroups([]);
        setChecked({});
        setExpanded({});

        // Clear the table data
        setFilteredPropertyData([]);
        //setPropertyData_TBL([]);
        setColumns([]);
        setTotalRecords(0);

        // Reset dropdown options
        setUlbs([]);
        setWards([]);

        // Dispatch reset actions
        dispatch(setIsDist(""));
        dispatch(setIsUlb(""));
        dispatch(setIsWard(""));

        /* 29SEP CODE FOR RESET DATA */
        setRelation_Id("");
        setSelectedRow("");
        setpropertyData("");
        setSelectedImageUrl("");
        setselectedGISUniqeID("");

        setRelation_Id("");

        setSelectedRow("");
        setpropertyData("");

        setSelectedImageUrl("");
        setselectedGISUniqeID("");
        setFilteredPropertyData("");





        /* 29SEP CODE FOR RESET DATA */

        // Reset map layers visibility if needed
        if (mapLayers) {
            Object.keys(mapLayers).forEach(groupKey => {
                const targetLayer = mapLayers[groupKey];
                if (targetLayer) {
                    // Hide all sublayers
                    targetLayer.sublayers.forEach(subLayer => {
                        subLayer.visible = false;
                    });
                }
            });
        }

        // Reset the map view to initial state
        if (view) {
            try {
                // Remove all graphics
                view.graphics.removeAll();

                // Go to initial view (India centered view)
                view.goTo({
                    center: [78.9629, 20.5937], // Center of India
                    zoom: 5
                }).catch(error => {
                    console.error("Error during goTo:", error);
                });
            } catch (error) {
                console.error("Error during refresh:", error);
            }
        } else {
            console.warn("View is not available");
        }

        // Reload districts (for non-authenticated users)
        if (!(authData?.UserType === "districtuser" || authData?.UserType === "User")) {
            const loadDistricts = async () => {
                const url = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/3/query?where=1=1&outFields=districtname,dist_cd&returnGeometry=false&returnDistinctValues=true&f=geojson";
                try {
                    const response = await fetch(url);
                    const data = await response.json();
                    const formatted = data.features.map(f => ({
                        districtName: f.properties.districtname,
                        districtCode: f.properties.dist_cd,
                    }));
                    setDistricts(formatted);
                } catch (err) {
                    console.error("Error loading districts:", err);
                }
            };
            loadDistricts();
        }
    };

    const formatNumberWithCommas = (value) => {
        if (value === null || value === undefined || value === '') return '';
        if (typeof value === 'string') {
            if (value.includes('/')) {
                const parts = value.split('/');
                if (parts.length === 2) {
                    const numerator = formatNumberWithCommas(parts[0]);
                    const denominator = formatNumberWithCommas(parts[1]);
                    return `${numerator}/${denominator}`;
                }
            }
            const numericMatch = value.match(/([-\d,.]+)(.*)/);
            if (numericMatch) {
                const numericPart = numericMatch[1].replace(/,/g, '');
                const unitPart = numericMatch[2];
                if (!isNaN(numericPart)) {
                    const num = Number(numericPart);
                    const formattedNumber = num.toLocaleString('en-IN');
                    return `${formattedNumber}${unitPart}`;
                }
            }
            return value;
        }
        if (typeof value === 'number') {
            return value.toLocaleString('en-IN');
        }
        return value;
    };

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            boxShadow: state.isFocused && !state.hasValue ? "0 0 0 1px #ccc" : "none",
            borderColor: state.isFocused && !state.hasValue ? "#ccc" : "#ccc",
            "&:hover": {
                borderColor: "#ccc",
            },
            fontSize: "12px",
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? "#d1ede9"
                : state.isFocused
                    ? "#d1ede9"
                    : "#FFFFFF",
            color: "#000",
            fontSize: "12px",
            padding: "10px",
        }),
        singleValue: (provided) => ({
            ...provided,
            color: "#000",
            fontSize: "12px",
        }),
        placeholder: (base) => ({
            ...base,
            color: "#000",
            fontSize: "12px",
        }),
        input: (provided) => ({
            ...provided,
            color: "#000",
            fontSize: "12px",
        }),
    };

    const notificationBodyTemplate = (rowData) => {
        return (
            <button
                className="btn btn-sm btn-outline-primary p-1"
                onClick={() => handleNotificationClick(rowData)}
                title="View notifications"
            >
                {/* <FaBell />  */} Send Notification
            </button>
        );
    };

    const handleNotificationClick = (rowData) => {
        console.log("Notification button clicked for row:", rowData);
        //  alert(`Notifications for property: ${rowData.property_id || rowData.objectid}`);
        setIsOwnerDetails(rowData)
        setIsChangeStage(!isChangeStage)

        // ZOOMTOProperty();
    };


    //  Bhupen 19sep code for row click
    const handleRowClick = (event) => {
        const rowData = event.data;
        console.log('Bhupen Row clicked:', rowData);
        //  alert(`Row clicked for property: ${rowData.relation_id}`);
        console.log('Bhupen Row clicked:', rowData.relation_id);
        setRelation_Id(rowData.relation_id)

        setSelectedRow(event.value);
        setpropertyData(rowData);

        const imageUrl = `https://urbangis.mp.gov.in/api/DownloadImage?Relation_Id=${rowData.relation_id}`;
        setSelectedImageUrl(imageUrl);
        setselectedGISUniqeID(rowData.gis_uniqueid);
        //  alert(`Row clicked for property: ${rowData.relation_id}`);

    };


    //download div 
    const printRef = useRef();





    //download div 
    // Assume this is your data object (you'll pass this from your component or fetch it)

    // Popup  Model View Controler 
    const modalStyles = {
        overlay: {
            position: 'fixed',
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(184, 217, 244, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            animation: 'fadeIn 0.3s ease',
            zIndex: 10000,
        },
        content: {

            paddingtop: '20px',
            borderRadius: '8px',
            color: '#041f3f',
            width: '700px',        // fixed width for square shape
            height: '500px',       // fixed height for square shape
            position: 'relative',  // needed for absolute positioning of close button
            overflowY: 'auto',
            animation: 'slideDown 0.3s ease',
            boxSizing: 'border-box', // include padding in width/height
            zIndex: 10000,
        },
        closeBtn: {

            cursor: 'pointer',
            position: 'absolute',
            top: '40px',
            right: '40px',
            borderRadius: '4px'

        },
        imgboderCSS: {
            borderRadius: '4px'

        }


        // code for 


    };


    // table css
    const styles = {

        lightbluerow: {
            backgroundColor: '#035f6fff',
        },


        primaryButton: {
            backgroundColor: '#035f6fff',
            color: 'white',
            border: 'none',
            paddingleft: '20px',
            borderRadius: '4px',
            cursor: 'pointer',
            width: '90px',
            height: "25px"
        },

        backgroundWrapper: {
            padding: '20px',
            backgroundColor: '#E6FFFA',

        },
        container: {
            maxWidth: '800px',
            margin: '0 auto',
            backgroundColor: '#fff',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 0 10px rgba(0,0,0,0.1)',


        },
        containerINside: {
            maxWidth: '800px',
            margin: '0 auto',
            backgroundColor: '#fff',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 0 10px rgba(0,0,0,0.1)',

        },
        heading: {
            textAlign: 'center',
            marginBottom: '20px',
            textDecoration: 'underline',
        },
        image: {
            display: 'block',
            maxWidth: '100%',
            height: 'auto',
            margin: '0 auto 20px',
            borderRadius: '4px',

        },
        labelCell: {
            fontWeight: 'bold',
            padding: '10px',
            backgroundColor: '#f0f0f0',
            width: '40%',
            verticalAlign: 'top',
            border: '1px solid #ccc',
            fontSize: "12px",
        },
        valueCell: {
            padding: '10px',
            border: '1px solid #ccc',
            width: '60%',
        },
        table: {
            width: '100%',
            borderCollapse: 'collapse',
            fontFamily: 'Arial, sans-serif',
            fontSize: '16px',
            tableLayout: 'fixed',

        },
        th: {
            border: '1px solid #333',
            verticalAlign: 'top',
            wordWrap: 'break-word',
            background: '#e6f0f9',
            textAlign: 'center',
            fontSize: '12px',
        },
        td: {
            border: '1px solid #333',
            padding: '6px',
            verticalAlign: 'top',
            wordWrap: 'break-word',
            textAlign: 'center',
        },
        sectionHeader: {
            background: '#b5cce6',
            textAlign: 'center',
            fontWeight: 'bold',
            fontSize: '16px',
            padding: '6px',
            border: '1px solid #333',
        },
        photoCell: {
            background: '#f5f5f5',
            textAlign: 'center',
            border: '1px solid #333',
            padding: '6px',
        },
        photoImg: {
            maxWidth: '100%',
            maxHeight: '250px',
            objectFit: 'contain',
            border: '1px solid #aaa',
            borderRadius: '4px',
        },


    };




    const [imageLoaded, setImageLoaded] = useState(false);
    const handleDownloadpdfwithImage = async () => {
        const element = printRef.current;

        // Wait for images to load
        const images = element.querySelectorAll('img');
        const imagePromises = Array.from(images).map((img) => {
            if (img.complete) return Promise.resolve();
            return new Promise((resolve, reject) => {
                img.onload = resolve;
                img.onerror = reject;
            });
        });

        try {
            await Promise.all(imagePromises);

            const canvas = await html2canvas(element, {
                scale: 2, // Higher resolution
                useCORS: true,
                allowTaint: false,
            });

            const imgData = canvas.toDataURL('image/png');

            // PDF Setup
            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: 'a4',
            });

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();

            const imgWidth = canvas.width;
            const imgHeight = canvas.height;

            // Convert px to mm (1 px = 0.264583 mm)
            const imgProps = {
                width: imgWidth * 0.264583,
                height: imgHeight * 0.264583,
            };

            // Scale to fit A4
            const ratio = Math.min(pdfWidth / imgProps.width, pdfHeight / imgProps.height);

            const scaledWidth = imgProps.width * ratio;
            const scaledHeight = imgProps.height * ratio;

            const x = (pdfWidth - scaledWidth) / 2;
            const y = (pdfHeight - scaledHeight) / 2;

            pdf.addImage(imgData, 'PNG', x, y, scaledWidth, scaledHeight);
            pdf.save(`${selectedGISUniqeID}.pdf`);

        } catch (error) {
            console.error('Image loading failed:', error);
            alert('Image failed to load. Cannot download.');
        }
    };

    // PropertyDetails component (same as before but receives data as props)
    function PropertyDetails({ data }) {
        return (
            <div style={styles.backgroundWrapper}>
                <div style={styles.container}  >
                    <button className='gradient-btn' onClick={handleDownloadpdfwithImage}>

                        <img src="img/gradiant-download.svg" alt='download' />
                        Download </button>

                    <button className='gradient-btn' style={modalStyles.closeBtn} onClick={() => setShowModal(false)}
                        aria-label="modal"> Close </button>
                    <div ref={printRef} style={styles.containerINside}>
                        <div className='mainheadertitle' style={{ marginBottom: "10px" }}>
                            <img src="img/mplogo.png" alt="Logo" className='header-img ' />
                            <div className='headmain'>
                                <h6 className="mb-0">Directorate, Urban Administration & Development </h6>
                                <h6 className="mb-0">
                                    Government of Madhya Pradesh</h6>
                            </div>
                        </div>

                        <table style={styles.table}>
                            {/* Property Info and Photo Section */}
                            <tbody>
                                <tr>
                                    <td colSpan="4" style={styles.sectionHeader}>
                                        Property Details
                                    </td>
                                </tr>
                                <tr>
                                    <th colSpan="2" style={styles.th}>Property ID/Assessment No: {data.e_nagarpalikaid} </th>
                                    <th colSpan="2" style={styles.th}>GIS UniqueID : {data.gis_uniqueid}</th>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: 'left', border: '1px solid black' }}  >Owner Name</td>
                                    <td style={styles.td}> {data.ownername} </td>
                                    <td colSpan="2" rowSpan="6" style={styles.photoCell}>
                                        <img src={selectedImageUrl} alt="" onLoad={() => setImageLoaded(true)}
                                            style={styles.image} />

                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: 'left', border: '1px solid black' }}>Father's Name</td>
                                    <td style={styles.td}>{data.ownerfathername}  </td>

                                </tr>
                                <tr>
                                    <td style={{ textAlign: 'left', border: '1px solid black' }}>Mobile No.</td>
                                    <td style={styles.td}> {data.mobileno}</td>

                                </tr>

                                <tr>
                                    <td style={{ textAlign: 'left', border: '1px solid black' }} >District</td>
                                    <td style={styles.td}>{data.districtname}</td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: 'left', border: '1px solid black' }} >ULB</td>
                                    <td style={styles.td}>{data.ulbname}</td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: 'left', border: '1px solid black' }} >Ward</td>
                                    <td style={styles.td}>{data.wardno}-{data.wardname} </td>

                                </tr>


                                {/* Comparison Section Header */}
                                <tr>
                                    <td colSpan="4" style={styles.sectionHeader}>
                                        ABPAS vs MPHS Survey Comparison Details
                                    </td>
                                </tr>
                                {/* Comparison Table */}
                                <tr>
                                    <th style={styles.th}>Description</th>
                                    <th style={styles.th}>ABPAS Approval</th>
                                    <th style={styles.th}>MPHS Survey</th>
                                    <th style={styles.th}>ABPAS vs MPHS (Difference/Status)</th>
                                </tr>
                                <tr>

                                    <td style={{ textAlign: 'left', border: '1px solid black' }} >Buildup Area (sqft)</td>
                                    <td style={styles.td}>{Number(data.abpas_builtup_area_sqft).toFixed(2)}</td>
                                    <td style={styles.td}>{Number(data.gis_builtup_area_sqft).toFixed(2)}</td>
                                    <td style={styles.td}>
                                        {Number(data.diff_builtup_area_sqft).toFixed(2)}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: 'left', border: '1px solid black' }} >Plot Area (sqft)</td>
                                    <td style={styles.td}>{Number(data.abpass_plot_area_sqft).toFixed(2)}</td>
                                    <td style={styles.td}>{Number(data.gis_plot_area_sqft).toFixed(2)} </td>
                                    <td style={styles.td}>{Number(data.diff_plot_area_sqft).toFixed(2)} </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: 'left', border: '1px solid black' }} >No of Floor</td>
                                    <td style={styles.td}> {data.abpas_no_of_floors}</td>
                                    <td style={styles.td}> {data.gis_no_of_floors}</td>
                                    <td style={styles.td}> {data.floor_status}</td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: 'left', border: '1px solid black' }} >Landuse Type</td>
                                    <td style={styles.td}>{data.abpas_land_use_type}</td>
                                    <td style={styles.td}> {data.gis_land_use_type}</td>
                                    <td style={styles.td}>{data.land_use_status}</td>
                                </tr>
                            </tbody>
                        </table>
                        <footer>
                            <div style={{ fontSize: "8px", float: "right" }}>
                                © 2025 Webportal by Garud MP GIS AI</div>
                        </footer>

                        <div style={{ height: '200px' }}>

                        </div>

                    </div>
                </div>
            </div>
        );
    }


    // const propertyData = {
    //     photolink: "uadddatapublishing/survey_photos/phase_04/guna/guna/1400127.JPG",
    //     gis_uniqueid: "23034580115001400127001",
    //     abpas_builtup_area_sqft: 1753.22,
    //     abpas_land_use_type: "Residential",
    //     abpas_no_of_floors: "G+2",
    //     abpass_plot_area_sqft: 1330.53,
    //     assesmentno: "1003167908",
    //     districtname: "Guna",
    //     floor_status: "Match",
    //     gis_builtup_area_sqft: "0.00",
    //     gis_land_use_type: "Residential",
    //     gis_no_of_floors: "Open",
    //     gis_plot_area_sqft: "2700.00",
    //     land_use_status: "Match",
    //     ownername: "Prakash Patodi",
    //     ownerfathername: "S/O Moolchand Patodi",
    //     wardname: "Vos Subhas Ward 14",
    //     wardno: "14",
    //     ulbname: "Guna"
    // };

    // Model View Controler


    //Code for 17sep 

    //01152000279




    // code for ro click


    // code for layers
    const [layerGroups, setLayerGroups] = useState(GROUPS);

    const toggleLayer = (groupTitle, sublayerId) => {
        const updatedGroups = layerGroups.map(group => {
            if (group.title !== groupTitle) return group;

            const updatedSublayers = group.sublayers.map(sublayer =>
                sublayer.id === sublayerId
                    ? { ...sublayer, visible: !sublayer.visible }
                    : sublayer
            );

            return { ...group, sublayers: updatedSublayers };
        });

        setLayerGroups(updatedGroups);
    };
    //  CODE FOR  SEARCH 

    const [relationIdSearch, setRelationIdSearch] = useState('');
    const [lastSearchTerm, setLastSearchTerm] = useState('');







    const onSearchClick = () => {
        const searchTerm = relationIdSearch.trim().toLowerCase();
        setLastSearchTerm(searchTerm);

        const filtered = PropertyData_TBL?.filter(item =>
            item?.e_nagarpalikaid?.toString().toLowerCase().includes(searchTerm)
        );

        if (filtered?.length > 0) {
            const firstMatch = filtered[0];
            console.log("First matching record:", firstMatch);

            //alert(`e_nagarpalikaid for property: ${firstMatch.e_nagarpalikaid}`);

            setRelation_Id(firstMatch.relation_id)

            setSelectedRow(firstMatch.value);
            setpropertyData(firstMatch);

            const imageUrl = `https://urbangis.mp.gov.in/api/DownloadImage?Relation_Id=${firstMatch.relation_id}`;
            setSelectedImageUrl(imageUrl);
            setselectedGISUniqeID(firstMatch.gis_uniqueid);
            setFilteredPropertyData(filtered);

            // You can do more with this, like auto-select or scroll
        }


    };
    // Apply filtering when search value or original data changes
    // code form MAP SELECTIOnID
    useEffect(() => {
        const initLoad = async () => {


        };

        if (authData) initLoad();
    }, [authData, rows]); // Re-run if `rows` changes



    // CODE FOR SEARCH
    return (
        <div style={{ border: "none", height: isToolHeight ? 'calc(100vh - 109px)' : 'calc(100vh - 205px)' }} className='px-2'>
            {/* The top part of your component (Map and Filters) remains unchanged */}
            <div className={isTableView ? 'd-none' : ''}>
                <div className='row' >
                    <div className={isBufferWidth ? 'col-md-12 p-0' : "col-md-9 p-0"}>
                        <MapABPASS
                            isLayerInfo={isPayload}
                            selectedDistrict={selectedDistrict}
                            selectedUlb={selectedUlb} selectedWard={selectedWard} districtCode={districtCode}
                            ulbCode={ulbCode} wardCode={wardCode}
                            activeTabinfo={active} activeTabRef={refactive}
                            dist_cd={districtCode} ulb_cd={ulbCode} wardno={wardCode}
                            groups={layerGroups} PROPERTY_Relation_Id={Relation_Id}
                        />
                    </div>
                    {!isBufferWidth && (
                        <div className='col-md-3 p-0'>
                            <div className='px-2'>
                                <div className='tooltitlediv linear-gradian-bg d-flex justify-content-between align-items-center px-3'>
                                    <h6 className='sidebarbuttontitle text-white m-0'>ABPAS & Survey Data Comparison</h6>
                                    {/* <button className='btn text-white no-hover'
                                        onClick={() => navigate("/link-dashboard")}
                                    >Back</button> */}
                                </div>

                                <div className="tabs-container d-flex justify-content-between mt-3">
                                    <button className={`tab-btn ${activeSelect === "area" ? "active" : ""}`} onClick={() => setActiveSelect("area")}>Select Area</button>
                                    <button className={`tab-btn ${activeSelect === "layer" ? "active" : ""}`} onClick={() => setActiveSelect("layer")} >Layer</button>
                                </div>
                                <div className={isToolHeight ? 'scroll-layerdiv' : 'scroll-layerdivheight '}>
                                    {activeSelect === "area" ?
                                        <>
                                            <Select
                                                options={districts.map((d) => ({ value: d.districtCode, label: d.districtName })).sort((a, b) => a.label.localeCompare(b.label))}
                                                value={districtCode ? { value: districtCode, label: selectedDistrict } : null}
                                                onChange={(selectedOption) => !selectedOption ? handleRefresh() : handleDistrictChange(selectedOption)}
                                                styles={customStyles} placeholder="Select District" isClearable={true} className="mt-3"
                                                isDisabled={authData?.UserType === "districtuser" || authData?.UserType === "User"}
                                            />
                                            <Select
                                                options={ulbs.map((u) => ({ value: u.ulbCode, label: u.ulbName })).sort((a, b) => a.label.localeCompare(b.label))}
                                                value={ulbCode ? { value: ulbCode, label: selectedUlb } : null}
                                                onChange={handleUlbChange} placeholder="Select ULB" isClearable={true}
                                                isDisabled={authData?.UserType === "districtuser" || authData?.UserType === "User" || !districtCode} className="mt-3" styles={customStyles}
                                            />
                                            <Select
                                                options={wards.map((w) => ({ value: w.wardCode, label: w.displayLabel })).sort((a, b) => Number(a.value) - Number(b.value))}
                                                value={wardCode ? { value: wardCode, label: wards.find(w => w.wardCode === wardCode)?.displayLabel } : null}
                                                onChange={handleWardChange} placeholder="Select ward" isClearable={true} isDisabled={!ulbCode} className="mt-3" styles={customStyles}
                                            />

                                        </>
                                        :
                                <LayerControlPanel groups={layerGroups} toggleLayer={toggleLayer} />

                                    }
                                    {!(authData?.UserType === "districtuser" || authData?.UserType === "User") &&
                                        <button className="btn-refresh2" onClick={handleRefresh} style={{ marginTop: "14px" }}>
                                            <img src={isTheme === 'light' ? "img/refreshlight.svg" : "img/refresh.svg"} alt="refresh" width="20px" height="20px" /> Refresh
                                        </button>

                                    }

                                    <div style={{ backgroundColor: "#E6FFFA" }}>

                                        {/*  code for popupdetails show */}

                                        {showModal && (
                                            <div style={modalStyles.overlay} onClick={() => setShowModal(false)}>
                                                <div style={modalStyles.content} aria-label="View"
                                                    onClick={e => e.stopPropagation()}>


                                                    {/* Your property details go here */}
                                                    <PropertyDetails data={propertyData} />
                                                </div>
                                            </div>
                                        )}
                                        {/* code for popupdetails show */}
                                        {/* Show the image if selected */}
                                        {selectedImageUrl && (
                                            <div style={{ color: "#000", border: "1px;", marginTop: '20px', background: "linear-gradient(135deg, #E6FFFA, #E6FFFA)" }}>
                                                <div className='tooltitlediv' style={{ borderRadius: "4px", border: '1px solid #041f3fff' }}>
                                                    <h6 style={{ color: "#000" }} className='sidebarbuttontitle  m-0'>Selected Property </h6>

                                                    <button
                                                        onClick={() => setShowModal(true)}
                                                        style={{
                                                            background: "linear-gradient(135deg, #04714dff, #0083b0)",
                                                            zIndex: 999,
                                                            backgroundColor: "linear-gradient(135deg, #047c6eff, #047c6eff)",
                                                            color: "#f4f7fcff", borderRadius: "4px",
                                                            fontWeight: "bold", width: "150px",          // 🔑 fixed width
                                                            height: "40px", left: '0px', fontSize: '16px'
                                                        }}
                                                    >
                                                        View Details
                                                    </button>
                                                    {/* Show GIS ID below the image */}

                                                    {selectedGISUniqeID && (
                                                        <p style={{ color: "#000" }} >
                                                            <strong>Gis Unique Id:</strong> {selectedGISUniqeID}
                                                        </p>
                                                    )}

                                                    <img src={selectedImageUrl} alt="Selected" style={{ width: '250px', }} />

                                                </div>
                                            </div>
                                        )}
                                        {/* Show the image if selected */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div className='px-2'>
                <div className='row align-items-center'>
                    <div className={isTableView ? 'col-md-12 mt-3' : 'col-md-12'}>
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="tabs-container">
                                <button className={`tab-btn ${active === "total" ? "active" : ""}`} onClick={() => filterProperties("total")}>GIS Surveyed vs ABPAS Approval</button>
                                <button className={`tab-btn ${active === "diff_builtup_area_sqft>50" ? "active" : ""}`} onClick={() => filterProperties("diff_builtup_area_sqft>50")}>Difference in Builtup Area</button>
                                <button className={`tab-btn ${active === "diff_plot_area_sqft>50" ? "active" : ""}`} onClick={() => filterProperties("diff_plot_area_sqft>50")}>Difference in Plot Area</button>
                                <button className={`tab-btn ${active === "floor_status='Mismatch'" ? "active" : ""}`} onClick={() => filterProperties("floor_status='Mismatch'")}>Floor Status</button>
                                <button className={`tab-btn ${active === "land_use_status='Mismatch'" ? "active" : ""}`} onClick={() => filterProperties("land_use_status='Mismatch'")}>Landuse Status</button>

                                {/* Search Box */}
                                <input type="text" placeholder="Search e-NagarpalikaID"
                                    className={` ${active === "land_use_status='Mismatch'" ? "active" : ""}`}

                                    value={relationIdSearch} onChange={(e) => setRelationIdSearch(e.target.value)}
                                    style={{ width: '150px', fontSize: '12px', height: "30px", marginRight: '10px' }} />

                                <button className={`tab-btn ${active === "land_use_status='Mismatch'" ? "active" : ""}`} onClick={handleRefresh}>
                                    <img src={isTheme === 'light' ? "img/refreshlight.svg" : "img/refresh.svg"}
                                        alt="refresh" borderRadius='8px' width="20px" height="20px" style={{ marginRight: '5px' }} />
                                </button>
                                <button className={`tab-btn ${active === "land_use_status='Mismatch'" ? "active" : ""}`} style={styles.primaryButton} marginleft="10px;" onClick={onSearchClick} >Search</button>




                            </div>
                            <div className='d-flex gap-3'>
                                {ulbCode && <button className='gradient-btn'
                                    onClick={downloadExcel}><img src="img/gradiant-download.svg" alt='download' /> Download Data</button>}
                                <button onClick={handleTableView} className='btn p-0 btn-titles btn-titlesdiv'><img src="img/expand-icon.svg" alt='Maximise Panel' />{isTableView ? 'Minimise' : "Maximise"} Table</button>
                            </div>
                        </div>

                        {/* REPLACEMENT: PrimeReact DataTable and Paginator */}
                        <div className='abpas-analysis-table-wrapper mt-2 relative table-indentify'>

                            <DataTable
                                value={filteredPropertyData}
                                scrollable
                                // scrollHeight={isTableView ? 'calc(100vh - 215px)' : '135px'}
                                scrollHeight={
                                    isTableView
                                        ? (isToolHeight ? "calc(100vh - 215px)" : "calc(100vh - 310px)")
                                        : (isToolHeight ? "135px" : "135px")
                                }

                                style={{ cursor: 'pointer', minWidth: '10rem', width: '100%' }}
                                loading={isTableLoading}
                                emptyMessage="No data found"
                                resizableColumns
                                columnResizeMode="expand"
                                className="custom-bordered-table" //

                                onRowClick={handleRowClick} // 19sep bhupen ✅ Add this line selection 
                                rowStyle={(rowData) => {
                                    if (
                                        lastSearchTerm &&
                                        rowData?.relation_id?.toString().toLowerCase().includes(lastSearchTerm)
                                    ) {
                                        return { backgroundColor: '#041f3fff' };
                                    }
                                    return {};
                                }}
                            >

                                {!isTableLoading && (
                                    <Column
                                        field="index"
                                        header="S.No"
                                        body={(data, options) => first + options.rowIndex + 1}
                                        headerStyle={{ textAlign: 'center', justifyContent: 'center' }}
                                        bodyStyle={{ textAlign: 'center', justifyContent: 'center' }}
                                    />
                                )}

                                {!isTableLoading && (
                                    <Column
                                        field="Action"
                                        header="Action"
                                        body={notificationBodyTemplate}
                                        style={{ width: '80px', textAlign: 'center' }}
                                        headerStyle={{ textAlign: 'center', justifyContent: 'center' }}
                                        bodyStyle={{ textAlign: 'center', justifyContent: 'center' }}
                                    />
                                )}

                                {columns.map((col) => (
                                    <Column
                                        key={col.field}
                                        field={col.field}
                                        header={col.header}
                                        sortable
                                        style={{ minWidth: '150px', maxWidth: '250px' }}
                                        // style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '150px' }}
                                        headerStyle={{ textAlign: 'center', justifyContent: 'center' }}
                                        bodyStyle={{ textAlign: 'center', justifyContent: 'center' }}
                                        body={(rowData) => (
                                            <span title={rowData[col.field]}
                                                className='text-center truncate-text'
                                                // onClick={() => handleRowData(rowData?.relation_id)}
                                                style={{ display: 'block', width: '100%' }}>
                                                {rowData[col.field]}</span>)}
                                    />
                                ))}

                            </DataTable>


                            {!isTableLoading && totalRecords > 0 && (
                                <div className="fixed-pagination custome-pagination">
                                    <Paginator
                                        first={first}
                                        rows={rows}
                                        totalRecords={totalRecords}
                                        rowsPerPageOptions={[100, 200, 500, 2000]}
                                        onPageChange={onPageChangePrimeReact}
                                        template={{
                                            layout: 'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown',
                                            RowsPerPageDropdown: (options) => {
                                                const dropdownOptions = [
                                                    { label: 100, value: 100 },
                                                    { label: 200, value: 200 }, { label: 500, value: 500 }, { label: 2000, value: 2000 }
                                                ];
                                                return (
                                                    <React.Fragment>
                                                        {/* <span className="p-mx-3" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Items per page: </span> */}
                                                        <select value={rows} onChange={(e) => onRowsChangePrimeReact(Number(e.target.value))}
                                                            style={{ padding: '0', borderRadius: '3px', border: '1px solid #ced4da' }}>
                                                            {dropdownOptions.map(option => (<option key={option.value} value={option.value}>{option.label}</option>))}
                                                        </select>
                                                    </React.Fragment>
                                                );
                                            }
                                        }}
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                        style={{ position: 'sticky', bottom: 0, backgroundColor: '#e6fffa', padding: '0.5rem', borderTop: '1px solid #dee2e6', zIndex: 10 }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>



            <Modal
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={isChangeStage}
                className="addusermodal"
            >
                <Modal.Header className="position-relative" style={{ backgroundColor: isTheme === "light" && "white" }}>
                    <div className="d-flex align-items-center w-100 justify-content-between">
                        <div className="btn-group text-white">
                            <button
                                className={`btn ${activeLang === "en" ? "btn-modal-submit" : "btn-light border"}`}
                                onClick={() => setActiveLang("en")}
                            >
                                English
                            </button>
                            <button
                                className={`btn ${activeLang === "hi" ? "btn-modal-submit" : "btn-light border"}`}
                                onClick={() => setActiveLang("hi")}
                            >
                                Hindi
                            </button>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body className="p-0 mt-2">
                    <div className="text-center">
                        {activeLang === "hi" ?
                            <h6 className="switch-text">
                                GIS विश्लेषण के आधार पर, संपत्ति क्रमांक {isOwnerDetails?.e_nagarpalikaid} की निर्माण स्थिति स्वीकृत भवन अनुज्ञा से भिन्न पाई गई है। कृपया संपत्ति मालिक को सूचित करें।
                            </h6>
                            :
                            <h6 className="switch-text">
                                Based on GIS analysis, the construction status of property category {isOwnerDetails?.e_nagarpalikaid} is found to be different from Chamber Bhawan Anuja. Please notify the property owner.
                            </h6>}
                    </div>
                    <div className="d-flex mt-4"
                        style={{
                            gap: "16px"
                        }}
                    >


                        <button className="btn-modal-submit w-100">
                            Send SMS to Owner
                        </button>
                        <button className="btn-cancel w-100" onClick={() => setIsChangeStage(false)}>
                            Cancel
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default ABPass
